/**
 * @generated SignedSource<<3c720d41c1f241682fc7a251a2afc629>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLMessageMessageType = "AGENT_PROCESS" | "AGENT_RESPONSE" | "ERROR_RESPONSE" | "USER_INPUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AgentThoughtProcess_formattedMessage$data = {
  readonly agentThoughtProcess: ReadonlyArray<{
    readonly subagentDescription: string | null | undefined;
    readonly subagentItems: ReadonlyArray<{
      readonly text: string | null | undefined;
      readonly thinking: string | null | undefined;
      readonly thinkingSummary: string | null | undefined;
      readonly toolUse: {
        readonly toolUse: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "SkillCluster_toolCall" | "ToolCallSheet_toolCall" | "V2AgentThoughtProcessRenderer_toolCall">;
      } | null | undefined;
    }> | null | undefined;
    readonly subagentOutput: string | null | undefined;
    readonly text: string | null | undefined;
    readonly thinking: string | null | undefined;
    readonly thinkingSummary: string | null | undefined;
    readonly toolUse: {
      readonly toolUse: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "SkillCluster_toolCall" | "ToolCallSheet_toolCall" | "V2AgentThoughtProcessRenderer_toolCall">;
    } | null | undefined;
  }>;
  readonly endedAt: any | null | undefined;
  readonly id: string;
  readonly messageType: GraphQLMessageMessageType | null | undefined;
  readonly startedAt: any;
  readonly " $fragmentType": "AgentThoughtProcess_formattedMessage";
};
export type AgentThoughtProcess_formattedMessage$key = {
  readonly " $data"?: AgentThoughtProcess_formattedMessage$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgentThoughtProcess_formattedMessage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinking",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinkingSummary",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMessageToolCall",
  "kind": "LinkedField",
  "name": "toolUse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "V2AgentThoughtProcessRenderer_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallSheet_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChecklistToolCallResult_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillCluster_toolCall"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentThoughtProcess_formattedMessage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAgentThoughtProcessItem",
      "kind": "LinkedField",
      "name": "agentThoughtProcess",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subagentDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subagentOutput",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAgentThoughtProcessItem",
          "kind": "LinkedField",
          "name": "subagentItems",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLFormattedMessage",
  "abstractKey": null
};
})();

(node as any).hash = "aee33e4d466c66f831846cbddbe10036";

export default node;
